import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Layout from './component/layout';
import Home from './pages/home';
import About from './pages/about';
import Resume from './pages/resume';
import Projects from './pages/projects';
import Contact from './pages/contact';
import NotFound from './pages/notFound';

const App = () => {
  let actualTheme;
  if (localStorage.theme === 'dark' || (!('theme' in localStorage) && window.matchMedia('(prefers-color-scheme: dark)').matches)) {
    document.documentElement.classList.add('dark');
    actualTheme = 'dark';
  } else {
    document.documentElement.classList.remove('dark');
    actualTheme = 'light';
  }

  return (
    <Router>
      <Routes>
        <Route index element={<Layout Design={Home} Theme={actualTheme} />} />
        <Route path="about" element={<Layout Design={About} Theme={actualTheme} />} />
        <Route path="resume" element={<Layout Design={Resume} Theme={actualTheme} />} />
        <Route path="projects" element={<Layout Design={Projects} Theme={actualTheme} />} />
        <Route path="contact" element={<Layout Design={Contact} Theme={actualTheme} />} />
        <Route path="*" element={<Layout Design={NotFound} />} Theme={actualTheme} />
      </Routes>
    </Router>
  );
};

export default App;
